import CheckIcon from "../assets/icons/checkIcon";

import { ArtistResponseDTOMin } from "../openapi-generated-client";
import "./userVerifiedIcon.css";

interface UserVerifiedIconMinProps {
    verified: boolean;
    noUser: boolean;
}

interface UserVerifiedIconProps {
    artist: ArtistResponseDTOMin | UserVerifiedIconMinProps;
}

export default function UserVerifiedIcon(props: UserVerifiedIconProps) {

    var checkIconExplanation = "Verified artist";
    if (props.artist.noUser) {
        checkIconExplanation = "Generated artist";
    }

    if(!props.artist.verified && !props.artist.noUser) return <></>;


    return <div title={checkIconExplanation} className={"verified-icon" + (props.artist.noUser ? " no-user" : "")}>
                <CheckIcon/>
            </div>

}